import { render, staticRenderFns } from "./ImportacaoArquivo.vue?vue&type=template&id=b8226cca&scoped=true&"
import script from "./ImportacaoArquivo.vue?vue&type=script&lang=js&"
export * from "./ImportacaoArquivo.vue?vue&type=script&lang=js&"
import style0 from "./ImportacaoArquivo.vue?vue&type=style&index=0&id=b8226cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8226cca",
  null
  
)

export default component.exports